import { Component, OnInit } from '@angular/core';
import { FaqDetailsService } from './faq-details.service';
import { ActivatedRoute, Router } from '@angular/router';
import { HeaderComponent } from '../../../../components/header/header.component';
import { FooterComponent } from '../../../../components/footer/footer.component';
import { FaqAccordionComponent } from './components/faq-accordion/faq-accordion.component';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MatIcon } from '@angular/material/icon';
import { FormsModule } from '@angular/forms';
import { FaqDataComponent } from './components/faq-data/faq-data.component';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-faq-details',
    standalone: true,
    imports: [
        HeaderComponent,
        FooterComponent,
        FaqAccordionComponent,
        CommonModule,
        TranslateModule,
        MatIcon,
        FormsModule,
        FaqDataComponent,
    ],
    templateUrl: './faq-details.component.html',
    styleUrl: './faq-details.component.scss',
})
export class FaqDetailsComponent implements OnInit {
    selectedLanguage: string = 'en';
    searchKeyword: string = '';
    selectedQuestionDetails: {} | null = null;
    activeIndex: number = 0;
    filteredQuestions: any = [];
    selectedQuestions: any = [];
    showDetails: boolean = false;
    categoryNameEn: string = '';
    categoryNameBm: string = '';
    filteredData: any = null;
    category: any = null;

    constructor(
        private _faqDetails: FaqDetailsService,
        private _route: ActivatedRoute,
        private _router: Router,
        private toastr: ToastrService,
    ) {}

    ngOnInit(): void {
        this.selectedLanguage = localStorage.getItem('language');
        this.setFAQsState();
    }

    setFAQsState() {
        this._route.paramMap.subscribe((params) => {
            const cat = params.get('category');
            this._faqDetails.getFaqDetails(cat).subscribe((category: any) => {
                if (!category) {
                    this.toastr.error('Data not found!');
                    this.goBack();
                }

                let finalFaqs = [];
                this.category = category;
                if (category?.faq) {
                    finalFaqs = category.faq;
                } else if (category?.subcategories) {
                    category?.subcategories?.map((sub) => {
                        finalFaqs.push(...sub.faq);
                    });
                }

                this.selectedQuestions = finalFaqs;
                this.filteredQuestions = finalFaqs;
                this.selectedQuestionDetails = this.filteredQuestions?.at(0);
                this.categoryNameEn = category.categoryEn;
                this.categoryNameBm = category.categoryBm;

                if (this.selectedQuestions.length > 0) {
                    this._route.queryParams.subscribe((params) => {
                        let question;
                        question = params['q'];
                        if (question) {
                            this.selectedQuestions?.filter((item, i) => {
                                const qEn = item.questionEn
                                    .replaceAll(' ', '-')
                                    .replaceAll('?', '')
                                    .toLowerCase();
                                const qBm = item.questionBm
                                    .replaceAll(' ', '-')
                                    .replaceAll('?', '')
                                    .toLowerCase();

                                if (qEn === question || qBm === question) {
                                    this.activeIndex = i;
                                    this.selectedQuestionDetails = item;
                                }
                            });
                        }
                    });
                }
            });
        });
    }

    switchedLanguage(data: any) {
        this.selectedLanguage = data;
    }

    toHomepageContactUs() {
        this._router.navigate(['']);
        localStorage.setItem('miti-enq', 'true');
    }

    switchLanguageHandler(data: any) {
        this.selectedLanguage = data;
    }

    searchQuestion(keyword: string) {
        keyword = keyword.toLowerCase();
        this.filteredQuestions = this.selectedQuestions.filter((item: any) => {
            if (this.selectedLanguage === 'en') {
                if (
                    item.questionEn.toLowerCase().includes(keyword) ||
                    item.answerEn.toLowerCase().includes(keyword)
                ) {
                    return item;
                }
            } else {
                if (
                    item.questionBm.toLowerCase().includes(keyword) ||
                    item.answerBm.toLowerCase().includes(keyword)
                ) {
                    return item;
                }
            }
        });

        this.selectedQuestionDetails = this.filteredQuestions?.at(0);
    }

    setQuestionDetails(q: string, index: number) {
        this.activeIndex = index;
        this.selectedQuestionDetails = q;
    }

    goBack() {
        this._router.navigate(['/faq']);
    }
}
